import L from 'leaflet';
import 'leaflet-easybutton';
import jQuery from 'jquery';

let map

function initMap() {
  map = new L.map('iradar')

  $('head').append(`<script src="https://stamen-maps.a.ssl.fastly.net/js/tile.stamen.js"></script>`)
}

// Get the current URL and any parameters specified therein
const urlParams = new URLSearchParams(window.location.search)

const paramLat = urlParams.get('lat')
const paramLon = urlParams.get('lon')
const paramZoom = urlParams.get('zoom') || 10

// Home (Default) Location logic
const getHomeLocation = (defaultLat, defaultLon) => {
  const userDefaultLocation = localStorage.getItem('userDefaultLocation')

  if (!userDefaultLocation) {
    map.setView([defaultLat, defaultLon], 8) 
    // Set view to Southeast CONUS if user does not give permission for geolocation
  } else {
    const savedLocation = JSON.parse(localStorage.getItem('userDefaultLocation'));
    const { lat, lon } = savedLocation
    map.setView([lat, lon], 8)
  }
}

// Re-center the view
function recenterMap(lat, lon) {
  map.setView([lat, lon], 8)
}

// Set up and display Basemap
const initLeaflet = (lat, lon) => {
  const Esri_WorldShadedRelief = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Shaded_Relief/MapServer/tile/{z}/{y}/{x}', {
    attribution: 'Tiles &copy; Esri &mdash; Source: Esri',
    maxZoom: 13
  })

  const Stamen_TonerHybrid = L.tileLayer('https://stamen-tiles-{s}.a.ssl.fastly.net/toner-hybrid/{z}/{x}/{y}{r}.{ext}', {
    attribution: 'Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    subdomains: 'abcd',
    minZoom: 0,
    maxZoom: 20,
    ext: 'png'
  })

  // Check if there is a latitude and longitude parameter in the URL. 
  // If so, go to that lat/lon on the map. Otherwise, attempt to get "home" or "default" location
  if (paramLat && paramLon) {
    map.setView([paramLat, paramLon], paramZoom)
  } else {
    getHomeLocation(lat, lon)
  }
  
  Esri_WorldShadedRelief.addTo(map)
  Stamen_TonerHybrid.addTo(map)

  L.easyButton('fa-home', function() {
    getHomeLocation()
  }).addTo(map)
}

export { initLeaflet, map, initMap, recenterMap }